export enum LogType {
  verbose= 'VERBOSE',
  error = 'ERROR',
  warning = 'WARNING',
  special = 'SPECIAL'
}
